interface Props {
  companyName?: string;
  complementIdentifier?: string;
  showOS?: boolean;
}
import './style.less';

export default function EtiquetteHeader({
  companyName,
  complementIdentifier,
  showOS,
}: Props) {
  return (
    <>
      <span className="etiquette-header-name">
        {companyName?.toUpperCase()}
      </span>

      {showOS && (
        <span className="etiquette-header-os">
          OS <span>#{complementIdentifier}</span>
        </span>
      )}
    </>
  );
}
